/* ---------------------------------------------------------------------------
 * Fixed swatch palette (locked 26 Sep 2026)
 * ---------------------------------------------------------------------------*/

export const COLOR_PICKER_SWATCHES: readonly string[] = [
  '#8b6df0', // mosaic-keep: data (user pickable swatch)
  '#2563eb', // mosaic-keep: data (user pickable swatch)
  '#0ea5e9', // mosaic-keep: data (user pickable swatch)
  '#14b8a6', // mosaic-keep: data (user pickable swatch)
  '#10b981', // mosaic-keep: data (user pickable swatch)
  '#84cc16', // mosaic-keep: data (user pickable swatch)
  '#eab308', // mosaic-keep: data (user pickable swatch)
  '#f59e0b', // mosaic-keep: data (user pickable swatch)
  '#f97316', // mosaic-keep: data (user pickable swatch)
  '#ef4444', // mosaic-keep: data (user pickable swatch)
  '#ec4899', // mosaic-keep: data (user pickable swatch)
  '#c084fc', // mosaic-keep: data (user pickable swatch)
  '#64748b', // mosaic-keep: data (user pickable swatch)
  '#78716c', // mosaic-keep: data (user pickable swatch)
  '#0f172a', // mosaic-keep: data (user pickable swatch)
  '#f8fafc', // mosaic-keep: data (user pickable swatch)
] as const
